import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <g clipPath="url(#magic_a)">
      <path
        fill="url(#magic_b)"
        stroke="url(#magic_c)"
        strokeWidth={1.161}
        d="M7.352 8.83c.08 0 .157.017.229.05l.068.04c.066.043.12.1.161.168l.036.07c.03.074.044.152.04.23l-.01.079a.534.534 0 0 1-.093.214l-.052.06a.533.533 0 0 1-.197.124l-.075.022a.535.535 0 0 1-.5-.164l-.05-.062a.536.536 0 0 1-.084-.218l-.006-.079c0-.106.032-.208.09-.295l.066-.082a.534.534 0 0 1 .273-.147l.104-.01Zm5.552 0c.079 0 .157.017.228.05l.069.04a.535.535 0 0 1 .162.168l.035.07a.535.535 0 0 1-.312.707l-.076.022a.534.534 0 0 1-.233-.005l-.075-.024a.535.535 0 0 1-.325-.415l-.005-.079c0-.106.03-.208.088-.295l.067-.082a.534.534 0 0 1 .272-.147l.105-.01Z"
      />
      <path
        fill="url(#magic_d)"
        stroke="url(#magic_e)"
        strokeWidth={0.78}
        d="M14.8 13.6c0 .644-.367 1.661-1.161 2.521-.782.846-1.959 1.518-3.555 1.518s-2.774-.676-3.559-1.524c-.797-.864-1.166-1.88-1.166-2.514 0-.042.004-.074.006-.098.032.003.075.01.133.022.126.026.282.07.484.129.757.22 1.968.59 3.74.635l.362.004c1.972 0 3.293-.407 4.099-.643.202-.06.357-.104.482-.13a1.28 1.28 0 0 1 .128-.022c.003.025.008.059.008.103Z"
      />
      <path
        fill="url(#magic_f)"
        stroke="url(#magic_g)"
        strokeWidth={0.29}
        d="M18.596 9.763a.635.635 0 0 1 .795.486 9.47 9.47 0 1 1-7.987-7.65c.366.051.597.41.52.772-.078.363-.435.59-.802.543a8.128 8.128 0 1 0 6.967 6.673c-.063-.365.149-.73.507-.824Z"
      />
      <path
        fill="url(#magic_h)"
        d="M17.572 8.163c-.313 0-.488-.156-.527-.468a16.433 16.433 0 0 0-.228-1.37c-.075-.328-.196-.575-.363-.743-.168-.168-.426-.299-.773-.393a17.318 17.318 0 0 0-1.47-.304c-.304-.055-.456-.23-.456-.527 0-.312.156-.488.468-.527a18.806 18.806 0 0 0 1.446-.246c.348-.078.607-.2.779-.368.171-.168.294-.422.369-.761.074-.34.15-.814.228-1.423.039-.32.214-.48.527-.48.312 0 .488.164.527.492.07.577.142 1.03.216 1.358.074.328.195.576.363.743.168.168.428.297.779.387.351.09.843.189 1.475.298.305.055.457.23.457.527 0 .305-.172.48-.515.527-.61.086-1.085.172-1.429.258-.343.086-.599.214-.767.386-.168.172-.289.425-.363.761a15.1 15.1 0 0 0-.216 1.382c-.04.327-.215.491-.527.491Z"
      />
    </g>
    <defs>
      <linearGradient
        id="magic_b"
        x1={6.435}
        x2={8.231}
        y1={8.306}
        y2={12.749}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="magic_c"
        x1={6.435}
        x2={8.231}
        y1={8.306}
        y2={12.749}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="magic_d"
        x1={5.227}
        x2={10.537}
        y1={13.229}
        y2={21.043}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="magic_e"
        x1={5.227}
        x2={10.537}
        y1={13.229}
        y2={21.043}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="magic_f"
        x1={1.089}
        x2={21.814}
        y1={2.984}
        y2={17.676}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="magic_g"
        x1={1.089}
        x2={21.814}
        y1={2.984}
        y2={17.676}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="magic_h"
        x1={10.492}
        x2={13.4}
        y1={-2.686}
        y2={10.587}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0560" />
        <stop offset={1} stopColor="#C700CC" />
      </linearGradient>
      <clipPath id="magic_a">
        <path fill="#fff" d="M0 0h22v22H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
